module.exports = __webpack_public_path__ + "img/Penny-Tote-03.1b021578.jpg";